import React, { useState } from "react";
import PageLayout from "../../components/PageLayout";
import DoctorCategories from "../../components/master/DoctorCategories";
import DoctorSpecializations from "../../components/master/DoctorSpecialization";

interface MasterPageProps {
    onLogout?: () => void;
    currentPage?: string;
    onNavigate?: (page: string) => void;
}

const DoctorMasterPage: React.FC<MasterPageProps> = ({
    onLogout,
    currentPage,
    onNavigate,
}) => {
    const [activeTab, setActiveTab] = useState<"categories" | "specializations">(
        "categories"
    );

    return (
        <PageLayout onLogout={onLogout} currentPage={currentPage} onNavigate={onNavigate}>
            <div className="p-6">
                {/* Page Header */}
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">
                        Doctor Master
                    </h1>
                    <p className="text-gray-500 text-sm">
                        Manage doctor categories and specializations
                    </p>
                </div>

                {/* Tabs */}
                <div className="flex gap-2 border-b mb-6">
                    <button
                        onClick={() => setActiveTab("categories")}
                        className={`px-4 py-2 text-sm font-medium border-b-2 transition ${activeTab === "categories"
                            ? "border-blue-600 text-blue-600"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                            }`}
                    >
                        Categories
                    </button>

                    <button
                        onClick={() => setActiveTab("specializations")}
                        className={`px-4 py-2 text-sm font-medium border-b-2 transition ${activeTab === "specializations"
                            ? "border-blue-600 text-blue-600"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                            }`}
                    >
                        Specializations
                    </button>
                </div>

                {/* Tab Content */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200">
                    {activeTab === "categories" && <DoctorCategories />}
                    {activeTab === "specializations" && <DoctorSpecializations />}
                </div>
            </div>
        </PageLayout>
    );
};

export default DoctorMasterPage;
